<template>
  <div class="star-rating">
    <span
      v-for="index in 5"
      :key="index"
      class="star">
      ★
      <span
        v-if="index <= eightNineRound(score)"
        class="full-star"
        >★</span
      >
      <span
        v-else-if="index === Math.ceil(score) && score % 1 >= 0.5"
        class="half-star"
        >★</span
      >
      <span
        v-else
        class="empty-star"
        >★</span
      >
    </span>
  </div>
</template>
<script setup>
const props = defineProps({
  score: {
    type: Number,
    required: true,
    default: 0,
  },
});

const eightNineRound = (num) => {
  // 分离整数和小数部分
  const intPart = Math.trunc(num);
  const decimal = num - intPart;

  // 获取小数点后第一位数字
  const firstDecimal = Math.floor(decimal * 10);

  // 8舍9入规则
  if (firstDecimal === 8) {
    return intPart; // 舍去小数
  } else if (firstDecimal === 9) {
    return intPart + 1; // 进位
  }
  return Math.floor(num);
};
</script>
<style lang="scss" scoped>
.star-rating {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  .star {
    position: relative;
    display: inline-block;
    width: 14px;
    height: 16px;
    line-height: 16px;
    margin-right: 2px;
    cursor: pointer;
    color: #ccc;
    span {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
  }
  .full-star {
    width: 100%;
    color: var(--main-color);
  }
  .half-star {
    color: var(--main-color);
    overflow: hidden;
    white-space: nowrap;
    width: 50%;
  }
  .empty-star {
    width: 0%;
    color: #ccc;
  }
}
</style>
